// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__FqVBt","container":"styles_container__2dp93","title":"styles_title__31G_Y","wrapper":"styles_wrapper__3K8od","answer":"styles_answer__2FOrZ"};